module.exports = __webpack_public_path__ + "img/hr-puberty-decal-03.4f63b0c6.png";